export const UI_TOPBAR_EXPAND = 'UI_TOPBAR_EXPAND'
export const UI_TOPBAR_COLLAPSE = 'UI_TOPBAR_COLLAPSE'

export const uiExpandTopBar = () => ({ type: UI_TOPBAR_EXPAND })
export const uiCollapseTopBar = () => ({ type: UI_TOPBAR_COLLAPSE })

export const UI_DRAWER_EXPAND = 'UI_DRAWER_EXPAND'
export const UI_DRAWER_COLLAPSE = 'UI_DRAWER_COLLAPSE'

export const uiExpandDrawer = () => ({ type: UI_DRAWER_EXPAND })
export const uiCollapseDrawer = () => ({ type: UI_DRAWER_COLLAPSE })

export const MOBILE_SEARCH_TOGGLE = 'MOBILE_SEARCH_TOGGLE'
export const MOBILE_SEARCH_ON = 'MOBILE_SEARCH_ON'
export const MOBILE_SEARCH_OFF = 'MOBILE_SEARCH_OFF'

export const uiMobileSearchOff = () => ({ type: MOBILE_SEARCH_OFF })
export const uiMobileSearchOn = () => ({ type: MOBILE_SEARCH_ON })
export const uiToggleMobileSearch = () => ({ type: MOBILE_SEARCH_TOGGLE })

export const UI_CONFIGURE_TOP_BAR = 'UI_CONFIGURE_TOP_BAR'
export const uiConfigureTopBar = config => ({
  type: UI_CONFIGURE_TOP_BAR,
  payload: config,
})

export const UI_CLEAR_CONFIGURE_TOP_BAR = 'UI_CLEAR_CONFIGURE_TOP_BAR'
export const uiClearConfigureTopBar = config => ({
  type: UI_CLEAR_CONFIGURE_TOP_BAR,
  payload: config,
})



// WEBPACK FOOTER //
// ./src/actions/ui.js